/**
 * (配車スケジュール 新規登録/詳細) 運転手設定ボタンScript関数ファイル
 */

/* Import Modules */
import $ from "jquery";

/* Copy Script */
// [運転手氏名に設定]ボタン 押下イベント
export const copyDriverNameFromContractorName = () => {
    // 保険情報.契約者氏名 → 運転手情報.運転手氏名
    $("#driver_name").val(null);
    $("#driver_name").val($("#contractor_name").val());
};

/**
 * グローバル関数を定義
 */

(window as any).copyDriverNameFromContractorName = copyDriverNameFromContractorName;
